import React from "react"
import { Main } from "../styles/Container"

export default function NotFound() {
  return <Main>Side ikke funnet</Main>
}
